import { useCallback } from 'react';
import { AnalyticsEventData, sendEventTracking } from 'src/components/Analytics';
import { createTrackingDataForProduct } from 'src/utils/trackingUtil';
import { useProductContext } from './ProductContextHooks';
import { useTrackingContext } from './TrackingContextHooks';

export const useTrackingEvent = () => {
  const { productInformation } = useProductContext();
  const { trackingConfiguration } = useTrackingContext();

  const sendSegmentTrackingEvent = useCallback(
    (analyticsEventData: AnalyticsEventData) => {
      sendEventTracking({
        ...trackingConfiguration,
        ...createTrackingDataForProduct(productInformation),
        ...analyticsEventData,
      } as AnalyticsEventData);
    },
    [productInformation, trackingConfiguration]
  );

  return { sendSegmentTrackingEvent };
};
